module.exports = __webpack_public_path__ + "img/sieckFinesseEnergy2.aa122dad.png";